<div class="left-side-container">
  <div class="left-side">
    <app-question-execution-numbers
      class="numbers"
      [questions]="questions"
      [currentQuestionId]="currentQuestion ? currentQuestion.questionId : 0"
      (selectQuestion)="onQuestionSelect($event)"></app-question-execution-numbers>
  </div>
</div>

<div class="content">
  <div class="top-bar">
    <div><span class="label">ФИО: </span>{{testExecution.studentName}}</div>
    <div *ngIf="testExecution.expiryDate">
      <span class="label">Осталось: </span>
      <app-timer [end]="testExecution.expiryDate"></app-timer>
    </div>
  </div>
  <div class="question-container">
    <app-question-execution *ngIf="currentQuestionNumber && currentQuestion"
                            class="question"
                            [executionId]="testExecution.id"
                            [question]="currentQuestion"
                            [number]="currentQuestionNumber"
                            [allQuestionsRequired]="allQuestionsRequired"
                            (changeQuestion)="onQuestionChange($event)"></app-question-execution>
  </div>
  <div class="bottom-bar">
    <div class="buttons">
      <div>
        <button *ngIf="currentQuestionNumber > 1" mat-raised-button color="primary"
                (click)="onPreviousQuestionSelect()">Предыдущий вопрос
        </button>
      </div>
      <div>
        <button *ngIf="currentQuestionNumber < questions.length" mat-raised-button color="primary"
                (click)="onNextQuestionSelect()">Следующий вопрос
        </button>
        <button *ngIf="currentQuestionNumber == questions.length" mat-raised-button color="warn"
                (click)="onExecutionFinish()">Завершить {{test.type === 'POLL' ? 'опрос' : 'тестирование'}}
        </button>
      </div>
    </div>
  </div>
</div>
